import { ConditionalRuleConfig } from './types';
import getDefaultConditionalRule from './getDefaultConditionalRule';
import { v4 as uuidv4 } from 'uuid';

export default () => {
  return {
    id: uuidv4(),
    rule: getDefaultConditionalRule().value,
    utilize: '',
    value1: 0,
    value2: 0
  } as ConditionalRuleConfig;
};
